import { useQuery } from "@tanstack/react-query";
import { fetchCountries } from "features/countries/fetchCounties";
import { useEffect } from "react";
import { useCountriesStore } from "stores/countries";

export const useCountryData = () => {
  const setCountries = useCountriesStore((state) => state.setCountries);
  const { data, isSuccess } = useQuery({
    queryKey: ["countries"],
    queryFn: fetchCountries,
  });

  useEffect(() => {
    if (isSuccess && data) {
      setCountries(data);
    }
  }, [isSuccess, data, setCountries]);
};
